export default {
    contactUs: 'Kontaktujte nás',
    contact: 'Kontakt',
    blogTitle: 'Budujeme budoucnost v péči o úsměv',
    blogDescription: 'Vyvíjíme produkty založené na přesvědčení, že bělení zubů může být účinné a bezpečné.',
    blogButton: 'Zobrazit vše',
    allAboutHelloCoco: 'Vše o hello coco',
    aboutUs: 'O nás',
    reviews: 'Recenze',
    reviewsLink: '/recenze/',
    cocoEmail: 'kontakt@hellococo.cz',
    termsAndConditions: 'Obchodní podmínky',
    termsAndConditionsLink: '/obchodni-podminky/',
    privacyPolicy: 'Ochrana soukromí',
    privacyPolicyLink: '/ochrana-soukromi/',
    purchase: 'Nákup',

    emptyCartText: 'Košík čeká na své první objevy - podívejte se na naši nabídku!',
    startShopping: 'Začít nakupovat',

    orderSummary: 'Rekapitulace objednávky',
    shippingAndPayment: 'Doprava a platba',
    discountCoupon: 'Slevový kupón',
    applyDiscount: 'Použít',
    giftsHeading: 'Vyberte si dárek ZDARMA',

    orderInfo: 'Informace o vás',
    orderNumber: 'Číslo objednávky',

    'header.others': 'Ostatní',
    'header.categories': 'Kategorie',
    'header.followUs': 'Sledujte nás',

    'emptyCart.title': 'Váš košík je prázdný',
    'emptyCart.backToShop': 'Zpět do obchodu',

    show_all: 'Zobrazit vše',

    aboutUsLink: '/o-nas/',
    contactUsLink: '/kontakt/',
}
